import type { NavConfig } from './types';

export const superAdminNav: NavConfig = {
  items: [
    {
      to: '/super-admin',
      icon: 'dashboard',
      label: 'Dashboard',
    },
    {
      to: '/super-admin/organizations',
      icon: 'corporate_fare',
      label: 'Organizations',
    },
    {
      to: '/super-admin/users',
      icon: 'people',
      label: 'Users',
      expandable: true,
      // Parent `/super-admin/users` already routes to "All Users" — no duplicate.
      subItems: [
        { to: '/super-admin/admins', label: 'Super Admins' },
        { to: '/super-admin/users?role=org_admin', label: 'Org Admins' },
        { to: '/super-admin/users?role=Learner', label: 'Learners' },
      ],
    },
    {
      to: '/super-admin/courses',
      icon: 'library_books',
      label: 'Content',
      expandable: true,
      // Parent `/super-admin/courses` already routes to "All Courses" — no duplicate.
      subItems: [
        // These five are content-category filters (by variant kind), not
        // Library entities — kept bare so "Libraries" below reads as the only
        // real curated-collection entry. The query key is `category` (not
        // `library`) precisely because these pages are NOT a Library.
        // One entry per kind ContentLibrary's getTypeForCategory maps: add a kind
        // there and here together, or the category page exists but nothing links
        // to it (BPE-696).
        { to: '/super-admin/courses?category=cle', label: 'CLE' },
        { to: '/super-admin/courses?category=cpe', label: 'CPE' },
        { to: '/super-admin/courses?category=microlearning', label: 'Microlearning' },
        { to: '/super-admin/courses?category=skills', label: 'Skills' },
        { to: '/super-admin/courses?category=simulation', label: 'Simulation' },
        { to: '/super-admin/libraries', label: 'Libraries' },
        { to: '/super-admin/pathways', label: 'Pathways' },
        { to: '/super-admin/bulk-update', label: 'Bulk Update' },
      ],
    },
    {
      icon: 'category',
      label: 'Catalog Data',
      expandable: true,
      subItems: [
        { to: '/super-admin/pass-types', label: 'Pass Types' },
        { to: '/super-admin/accreditations', label: 'Accreditations' },
        { to: '/super-admin/jurisdictions', label: 'Jurisdictions' },
        { to: '/super-admin/credit-types', label: 'Credit Types' },
        { to: '/super-admin/practice-areas', label: 'Practice Areas' },
        { to: '/super-admin/ml-practice-areas', label: 'ML Practice Areas' },
        { to: '/super-admin/skills', label: 'Skills' },

        // The curated vocabulary simulations are tagged with (BPE-698). Sits
        // with the other catalog lookups rather than under Content, because it
        // is a vocabulary an admin curates, not a course surface.
        { to: '/super-admin/competencies', label: 'Competencies' },
        { to: '/super-admin/presenters', label: 'Presenters' },
      ],
    },
    {
      icon: 'campaign',
      label: 'Marketing',
      expandable: true,
      subItems: [
        { to: '/super-admin/marketing-campaigns', label: 'Campaigns' },
      ],
    },
    {
      to: '/super-admin/reports/organizations',
      icon: 'analytics',
      label: 'Reports',
      expandable: true,
      // Parent already routes to the Organizations report — no duplicate.
      subItems: [
        { to: '/super-admin/reports/users', label: 'Users' },
        { to: '/super-admin/reports/content', label: 'Content' },
        { to: '/super-admin/reports/jurisdictions', label: 'Jurisdictions' },
        { to: '/super-admin/reports/who-to-apply-for', label: 'Who to Apply For' },
        { to: '/super-admin/analytics', label: 'Platform Activity' },
      ],
    },
    {
      icon: 'settings',
      label: 'Settings',
      expandable: true,
      subItems: [
        { to: '/super-admin/search', label: 'Search Console' },
        { to: '/super-admin/video-migration', label: 'Video Migration' },
        { to: '/super-admin/salesforce-sync', label: 'Salesforce Sync' },
        { to: '/super-admin/external-assessments', label: 'External CPE Assessments' },
        { to: '/super-admin/beacon-audit-batches', label: 'Beacon Audit Batches' },
        { to: '/super-admin/settings/system', label: 'System Settings' },
        { to: '/super-admin/settings/certificate-templates', label: 'Certificate Templates' },
      ],
    },
  ],
};
